import { resolveStoredFileUrl } from "utils/storedFileUrl";
// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  ImageList,
  ImageListItem,
  InputLabel,
  Menu,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";

import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import SinDatos from "components/Carteles/SinDatos";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "60%", xxl: "50%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalUsuarios({ open, handleClose, refetch, selectedUsuario }) {

  const [dataDNI, setDataDNI] = useState([]);
  const [dataCertificados, setDataCertificados] = useState([]);

  useEffect(() => {
    if (selectedUsuario) {
      setDataDNI(selectedUsuario?.documentosFile || []);
      setDataCertificados(selectedUsuario?.certificadoFile || []);
    }
  }, [selectedUsuario]);

  const handleClickDocument = (url) => {
    window.open(resolveStoredFileUrl(url),
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
    );
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Documentos del usuario</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SoftTypography variant="h6">Fotos DNI</SoftTypography>
                {dataDNI ? (
                  <ImageList sx={{ height: 200 }} cols={3} rowHeight={164}>
                    {(dataDNI || []).map((foto, index) => (
                      <ImageListItem key={index} onClick={() => { handleClickDocument(foto) }}>
                        <img
                          src={resolveStoredFileUrl(foto)}
                          alt={`foto-${index}`}
                          loading="lazy"
                          style={{ objectFit: "contain", width: "100%", height: "100%" }}
                        />
                        {/* <SoftButton
                          color="error"
                          sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "white",
                          }}
                          onClick={() => handleDeleteFoto(foto.id)} // Elimina la foto cuando el usuario haga clic
                        >
                          <Icon sx={{ fontSize: 20 }}>delete</Icon>
                        </SoftButton> */}
                      </ImageListItem>
                    ))}
                  </ImageList>
                ) : (
                  <SoftTypography variant="caption">Cargando fotos...</SoftTypography>
                )}
              </Grid>

              <Grid item xs={6}>
                <SoftTypography variant="h6">Certificados</SoftTypography>
                {dataCertificados ? (
                  <ImageList sx={{ height: 200 }} cols={3} rowHeight={164}>
                    {(dataCertificados || []).map((foto, index) => (
                      <ImageListItem key={index} onClick={() => { handleClickDocument(foto) }} sx={{cursor: "pointer"}}>
                        {foto.type?.startsWith("image") ? (
                          <img
                            src={resolveStoredFileUrl(foto)}
                            alt={`foto-${index}`}
                            loading="lazy"
                            style={{ objectFit: "contain", width: "100%", height: "100%" }}
                          />
                        ):(
                          <SoftBox
                            width="100%"
                            height="100%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="column"
                            gap={1}
                          >
                            <SoftBox display="flex" justifyContent="center" alignItems="center" width="100px" height="100px" border="1px solid #ccc" borderRadius="1rem">
                              <Icon fontSize="large">insert_drive_file</Icon>
                            </SoftBox>
                            <SoftTypography variant="caption">Documento</SoftTypography>
                          </SoftBox>
                        )}
                      </ImageListItem>
                    ))}
                  </ImageList>
                ) : (
                  <SoftTypography variant="caption">Cargando fotos...</SoftTypography>
                )}
              </Grid>

            </Grid>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalUsuarios.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  selectedUsuario: PropTypes.object,
};
